module.exports = __webpack_public_path__ + "img/ruhani-background.4b19019c.svg";